<script setup lang="ts">
import { computed } from 'vue'

import { Button, type ButtonSize } from '@collector/shared-ui'
import { getParticipantTeamSide } from '@collector/shared-ui-domain'
import { Participant } from '@collector/sportsapi-client-legacy'

// props
interface Props {
  participant: Participant
  size?: ButtonSize
}

const props = defineProps<Props>()

// data
const hoverVariantClass = 'hover:border-transparent'
const fontClass = 'font-bold'
const textClass = 'text-neutral-light-10'

const homeButtonColorClasses = [
  'bg-current-team-home-5',
  'border-current-team-home-5',
  'hover:bg-current-team-home-5/80',
]
const awayButtonColorClasses = [
  'bg-current-team-away-5',
  'border-current-team-away-5',
  'hover:bg-current-team-away-5/80',
]

// computed
const teamButtonColorClasses = computed(() => {
  const teamSide = getParticipantTeamSide(props.participant)

  return teamSide === 'home' ? homeButtonColorClasses : awayButtonColorClasses
})
const classes = computed(() => [
  ...teamButtonColorClasses.value,
  textClass,
  fontClass,
  hoverVariantClass,
])
</script>

<template>
  <Button
    :class="[
      ...classes,
      $attrs.class,
      'truncate',
      'text-wrap!',
      'leading-3',
      '@md:leading-none',
    ]"
    :size
  >
    {{ participant.short_name }}
  </Button>
</template>
